import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import * as actions from "../../../../_redux/school-reports/SchoolReportsAction";
import { noRecordsAlert, resultAlert } from "../../../../../../../_helpers/Helpers";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../../_metronic/_partials/controls";
import { useSchoolReportSectionsUIContext } from "./SchoolReportSectionsUIContext";
import { SchoolReportSectionsFilter } from "./school-report-sections-filter/SchoolReportSectionsFilter";
import { SchoolReportSectionsTable } from "./school-report-sections-table/SchoolReportSectionsTable";

export function SchoolReportSectionsCard({
  reportId,
  goNext
}) {
  // School Report Sections UI Context
  const schoolReportSectionsUIContext = useSchoolReportSectionsUIContext();
  const schoolReportSectionsUIProps = useMemo(() => {
    return {
      ids: schoolReportSectionsUIContext.ids
    };
  }, [schoolReportSectionsUIContext]);
    
  // Getting curret state of School Report list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.schoolReports }),
    shallowEqual
  );
  const { actionsLoading } = currentState;

  // School Reports Redux state
  const dispatch = useDispatch();

  /** Belli Bir Okul Karnesinin Hazırlanacağı Sınıf Listesini Kaydeder */
  const saveReceipents = (ids) => {
    if (ids.length < 1) {
      noRecordsAlert();
      return;
    }      
    dispatch(actions.saveReceipents(reportId, ids)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => goNext(), 2500);
  };

  const title = <>Karne Sınıfları{schoolReportSectionsUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{schoolReportSectionsUIProps.ids.length}</span>]</> : ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => saveReceipents(schoolReportSectionsUIProps.ids)}
          >
            Kaydet ve İlerle
            <span className="svg-icon svg-icon-md ml-1">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-right.svg")} />
            </span>
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <SchoolReportSectionsFilter />
        <SchoolReportSectionsTable />
      </CardBody>
    </Card>
  );
}